module.exports = __webpack_public_path__ + "img/sales.dcf1b393.svg";